// Blob ko browser download ke taur par save karta hai (HttpClient se aayi file ke liye,
// taake auth interceptor Bearer token laga sake).
export function saveBlob(blob: Blob, fileName: string): void {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
}
